"use client";

import { AlertCircle, ArrowLeft, type LucideIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { ErrorPageCard } from "./error-page-card";

interface ErrorPageContentProps {
  error: Error & { digest?: string };
  reset: () => void;
  title?: string;
  description?: string;
  icon?: LucideIcon;
  navigation: {
    label: string;
    href: string;
  };
  variant?: "centered" | "card";
  showStack?: boolean;
  reportTitlePrefix?: string;
  reportable?: boolean;
}

function NavigationButton({
  navigation,
}: {
  navigation: ErrorPageContentProps["navigation"];
}) {
  return (
    <Button variant="outline" asChild className="w-full">
      <a href={navigation.href}>
        <ArrowLeft className="size-4" />
        {navigation.label}
      </a>
    </Button>
  );
}

export function ErrorPageContent({
  title = "This page didn't load",
  icon = AlertCircle,
  navigation,
  variant = "centered",
  showStack = true,
  reportable = true,
  ...props
}: ErrorPageContentProps) {
  return (
    <ErrorPageCard
      {...props}
      variant={variant}
      title={title}
      icon={icon}
      navButton={<NavigationButton navigation={navigation} />}
      showStack={showStack}
      reportable={reportable}
    />
  );
}
